import { animateScroll as scroll} from 'react-scroll';
export const scrollToTop = ()=>{
    return scroll.scrollToTop();
}